/**
 * pf
 */
export default
    {

        path: "/bs",
        component: () => import('@/views/MainContent/MainContent'),
        children: [
            {
                path: '/workspace/analysis',
                name: '/workspace/analysis',
                component: () => import('@/views/bs/workspace/analysisi.vue'),
                meta: {
                    keepAlive: false,
                    title: '商家工作台'
                }
            },
            {
                path: 'workspace/noticeList',
                name: 'workspace/noticeList',
                component: () => import('@/views/bs/workspace/noticeList.vue'),
                meta: {
                    keepAlive: false,
                    title: '全部公告'
                }
            },
            {
                path: 'shop/list',
                name: 'shop/list',
                component: () => import('@/views/bs/shop/list.vue'),
                meta: {
                    keepAlive: true,
                    title:'店铺列表'
                }
            },
            {
                path: 'goods/pfSku',
                name: 'goods/pfSku',
                component: () => import('@/views/pf/pfSku/index.vue'),
                meta: {
                    keepAlive: true,
                    title:'平台SKU'
                }
            },
            {
                path: 'goods/mainSku',
                name: 'bsgoodsmainSku',
                component: () => import('@/views/pf/mainSku/index.vue'),
                meta: {
                    keepAlive: true,
                    title:'仓库SKU'
                }
            },
            {
                path: 'goods/edit',
                name: 'goods/edit',
                component: () => import('@/views/pf/mainSku/edit.vue'),
                meta: {
                    keepAlive: false,
                    title:'编辑仓库SKU'
                }
            },
            {
                path: 'goods/add',
                name: 'goods/add',
                component: () => import('@/views/pf/mainSku/edit.vue'),
                meta: {
                    keepAlive: false,
                    title:'新增仓库SKU'
                }
            },
            {
                path: 'stock/list',
                name: 'stock/list',
                component: () => import('@/views/bs/stock/warehouse/list.vue'),
                meta: {
                    keepAlive: true,
                    title:'库存查询'
                }
            },
            {
                path: 'stock/purchase',
                name: 'stockpurchase',
                component: () => import('@/views/bs/stock/purchase/list.vue'),
                meta: {
                    keepAlive: true,
                    title:'采购单'
                }
            },
            {
                path: 'stock/purchaseEdit',
                name: 'stock/purchaseEdit',
                component: () => import('@/views/bs/stock/purchaseEdit/index.vue'),
                meta: {
                    keepAlive: false,
                    title:'新增采购单'
                }
            },
            {
                path: 'stock/purchaseDetail',
                name: 'stock/purchaseDetail',
                component: () => import('@/views/pf/purchase/detail.vue'),
                meta: {
                    keepAlive: true,
                    title:'采购单详情'
                }
            },
            {
                path: 'order/list',
                name: 'orderlist',
                component: () => import('@/views/bs/order/tags.vue'),
                meta: {
                    keepAlive: true,
                    title:'订单列表'
                }
            },
            {
                path: 'order/refund',
                name: 'orderrefund',
                component: () => import('@/views/bs/refund/tags.vue'),
                meta: {
                    keepAlive: true,
                    title:'退货列表'
                }
            },
            {
                path: 'order/private-order',
                name: 'order/private-order',
                component: () => import('@/views/pf/purchase/private-order/tags.vue'),
                meta: {
                    keepAlive: true,
                    title:'私发单列表'
                }
            },
            {
                path: 'order/privateEdit',
                name: 'order/privateEdit',
                component: () => import('@/views/pf/purchase/private-order/privateEdit.vue'),
                meta: {
                    keepAlive: true,
                    title:'编辑私发单'
                }
            },
            {
                path: 'acct/bill-list',
                name: 'acct/bill-list',
                component: () => import('@/views/bs/acct/bill-list/list.vue'),
                meta: {
                    keepAlive: false,
                    title:'我的账单'
                }
            },
            {
                path: 'acct/verify-record',
                name: 'acctverify-record',
                component: () => import('@/views/bs/acct/verify-record/tags.vue'),
                meta: {
                    keepAlive: false,
                    title:'账单对账'
                }
            },
            {
                path: 'acct/bill-detail',
                name: 'acctbilldetail',
                component: () => import('@/views/pf/acct/shop/bill-detail.vue'),
                meta: {
                    keepAlive: false,
                    title:'账单详情'
                }
            },
            {
                path: 'acct/charge-list',
                name: 'chargeList',
                component: () => import('@/views/pf/acct/charge-list'),
                meta: {
                    keepAlive: false,
                    title: '充值列表'
                }
            },
            {
                path: 'acct/add-charge',
                name: 'add-charge',
                component: () => import('@/views/bs/add-charge'),
                meta: {
                    keepAlive: false,
                    title: '账户充值'
                }
            },
            {
                path: 'acct/bill-flow',
                name: 'billFlow',
                component: () => import('@/views/pf/acct/bill-flow'),
                meta: {
                    keepAlive: true,
                    title:'收支明细'
                }
            },
            {
                path: 'acct/freeze-log',
                name: 'freezeLog',
                component: () => import('@/views/pf/acct/freeze-log'),
                meta: {
                    keepAlive: true,
                    title:'冻结明细'
                }
            },
            {
                path: 'user/list',
                name: 'user/list',
                component: () => import('@/views/pf/user/List.vue'),
                meta: {
                    keepAlive: true,
                    title:'员工列表'
                }
            },
            {
                path: 'report/sale',
                name: 'report/sale',
                component: () => import('@/views/bs/report/sale.vue'),
                meta: {
                    keepAlive: false,
                    title:'销售订单统计'
                }
            },
            {
                path: 'report/goods',
                name: 'report/goods',
                component: () => import('@/views/bs/report/goods.vue'),
                meta: {
                    keepAlive: false,
                    title:'销售商品统计'
                }
            },

        ],

    }



// WEBPACK FOOTER //
// ./src/router/bs.js